import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: \"The Covalent Network Docs: Exploring the Covalent Network\"\ndate: 2022-03-09T1:00:15-05:00\ncategories: [\"product\"]\ndescription: Laying the foundation of a rich resource centre for all things Covalent Network!\nauthor: niall\nsubbrand_image: https://www.covalenthq.com/static/images/blog/202203/networkdocs-blog.jpg\ntype: legacy\n---\n\n**TL;DR**\n\n- The Covalent Network Docs are now live!\n- This space will serve as the home of all resources regarding the Covalent Network.\n- As the Covalent Network is developed and further roles become operational, resources will be added to the documentation.\n\n\n\n\n## Laying the Foundation for a Rich Resource Centre\n\nA critical component to any piece of software is good documentation. Late last year, Covalent delivered a revamped version of the reference documentation of its Unified Blockchain APIs. Today, Covalent is delighted to launch the Covalent Network Documentation which will serve as the network's resource centre as we march toward launching staking. \n\nThe Covalent Network documentation is by no means a finished product. Rather, the beginning of a collaborative effort between network stakeholders to create a vibrant collection of network resources.\n\nYou can expect to find:\n\n- Information about how the Covalent Network will work\n- Network Operator roles\n- CQT and its utility\n- Guides\n- ... and much more.\n\n![Image](https://www.covalenthq.com/static/images/blog/202203/homepage.png)\n\n[Read the Covalent Network Docs](https://www.covalenthq.com/docs/covalent-network/)\n\n## Building Trust\n\nWith a decentralized or distributed system, trust is paramount. Without trust embedded, encouraged and facilitated within a system, you cannot expect the stakeholders to interact and cooperate honestly with one another. Each network operator should be able to trust one another. Each delegator should be able to trust each network operator. Information is critical to this.\n\nAs Covalent develops the infrastructure to enable a decentralized blockchain data indexing and querying model, we will also create facilitates that build trust. The Covalent Network Documentation is one such facility that will develop into a rich resource centre where any network stakeholder can learn more about the Covalent Network.\n\n## The Path Forward\n\nThe Covalent Network documents will be ever-expanding. As further network roles go live, operational requirements and details about the role will be referenced. As new network terms are defined, they will be added to the glossary. And of course, means for the community to contribute.\n\nIn the Covalent Discord, you can now find the Covalent Network category. Here, you can ask questions regarding the Covalent Network and provide any feedback you see fit.\n\n\n\n\n\n";
const filepath = "/blog/network-docs-announcement.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
